export default "__VITE_PUBLIC_ASSET__7af9ef32__"